
import React from 'react';
import './App.css'; 
import Screen from './main';

function App() {
  return (
    <div className="app">
      <Screen />
    </div>
  );
}

export default App;
